var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.453125,
    y: 0.101562,
    width: 24.0736,
    height: 24.0736,
    rx: 12.0368,
    fill: "black",
    fillOpacity: 0.03
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.46094,
    y: 3.10938,
    width: 18.0552,
    height: 18.0552,
    rx: 9.02759,
    fill: "#006644"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48047 12.369L11.3323 14.208L15.4989 10.0703",
    stroke: "white",
    strokeWidth: 1.12845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.3a512b8b219a127f4e2570713c9a08b6.svg";
export { ForwardRef as ReactComponent };